import type { Settings } from '@core/settings/schema.ts';

export type DictationMaskSettings = Pick<
  Settings,
  'dictationFilteredWords' | 'dictationIgnoreBracketedText'
>;

/**
 * Port of extension sharedUtils.maskText — masks non-preserved characters with `mask`.
 */
export function maskDictationText(
  str: string,
  settings: DictationMaskSettings,
  mask = '_',
): string {
  const preserveWords = settings.dictationFilteredWords.split(',');

  const preservePatterns: RegExp[] = [
    /^[\w\s]+:/,
    /\[[^\]]*\]/,
  ];

  if (settings.dictationIgnoreBracketedText) {
    preservePatterns.push(/[（(][^）)]*[）)]/);
  }

  const filtered = preserveWords.filter((w) => w.trim().length > 0);
  if (filtered.length > 0) {
    preservePatterns.push(new RegExp(`\\b(${filtered.join('|')})\\b`, 'i'));
  }

  const preserveGroup = preservePatterns.map((p) => `(${p.source})`).join('|');
  const fullPattern = new RegExp(`${preserveGroup}|[^\\p{P}\\p{S}\\s]`, 'gui');

  return str
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(fullPattern, (match, ...groups) => {
      const hasPreserveMatch = groups.slice(0, preservePatterns.length).some(Boolean);
      return hasPreserveMatch ? match : mask;
    });
}
